import type { ReactNode } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import useLocalization from '../../../../hooks/useLocalization';

const styles = {
  header: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    pb: 2,
    borderBottom: '1px solid',
    borderColor: 'divider',
  },
  headerSide: {
    width: 40,
    flexShrink: 0,
  },
  headerSideRight: {
    width: 40,
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  navButton: {
    color: 'neutral.300',
    '&:hover': { color: 'text.primary' },
  },
  closeButton: {
    display: { xs: 'none', md: 'flex' },
  },
  navIcon: {
    fontSize: { xs: '1rem', md: '1.125rem' },
  },
  balanceSection: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 0.25,
  },
  balanceLabel: {
    typography: 'caption',
    fontWeight: 700,
    color: 'neutral.300',
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
  },
  balanceValue: {
    typography: { xs: 'h3', md: 'h2' },
    fontWeight: { xs: 800, md: 800 },
    color: 'text.primary',
    lineHeight: 1.2,
  },
} as const;

type NeobetWalletModalHeaderProps = {
  onClose: () => void;
  balanceContent: ReactNode;
};

const NeobetWalletModalHeader = ({ onClose, balanceContent }: NeobetWalletModalHeaderProps) => {
  const { t } = useLocalization();

  return (
    <Box sx={styles.header}>
      <Box sx={styles.headerSide} />
      <Box sx={styles.balanceSection}>
        <Typography sx={styles.balanceLabel}>{t('balance')}</Typography>
        <Typography sx={styles.balanceValue}>{balanceContent}</Typography>
      </Box>
      <Box sx={styles.headerSideRight}>
        <IconButton aria-label={t('close')} onClick={onClose} sx={{ ...styles.navButton, ...styles.closeButton }}>
          <CloseIcon sx={styles.navIcon} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default NeobetWalletModalHeader;
